<template>
    <section>
        <PageTitle title="Delivery Monster Customers" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/customers',title:'customers'}]" />
        <div class="wrapper wrapper-content animated fadeInRight">
            <div class="row">
                <div class="col-lg-12">
                    <div class="ibox-title">
                        <h5 class="pull-left">Delivery Monster Customers</h5>
                        <a v-on:click="loadEmptyCustomer()" class="pull-right" >Add New Customer</a>            
                        <!-- Reseting data on modal  -->
                    </div>
                    <div class="ibox-content">
                        <!-- Creating small -->
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Customer Status</label>
                                    <select v-model="customerStatus" class="form-control">
                                        <option value="">Select Status</option>
                                        <option value="active">Active</option>
                                        <option value="request_to_block">Request To Block</option>
                                        <option value="blocked">Block</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Address Status</label>
                                    <select v-model="customerAddressDeleted" class="form-control">
                                        <option value="">Select Address Status</option>
                                        <option value="0">Active</option>
                                        <option value="2">Request To Disable</option>                                        
                                        <option value="1">Disabled</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-3">
                              <search-customer-by-name-and-contact-number
                                  ref="searchCustomerComponent"
                                  :bayked-orders="false"
                                  :is-deleted=null
                                  @selectedCustomer="(event) => this.selectedCustomer = (event != null) ? event.id : null"
                              />
                            </div>
                            <div class="col-md-3">
                                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_filter_customer_btn"><i class="fa fa-search"></i> Search</button>
                                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_filter_customer_btn"><i class="fa fa-refresh"></i> Refresh</button>
                            </div>
                        </div>                        
                        <div class="table-responsive">
                            <table class="table table-striped table-responsive table-bordered table-hover" id="dtTable">
                                <thead>
                                    <tr>
                                        <th>Customer ID</th>
                                        <th>Name</th>
                                        <th>Contact 1</th>
                                        <th>Contact 2</th>
                                        <th>Contact 3</th>
                                        <th>Email</th>
                                        <th>Created</th>
                                        <th>Modified</th>
                                        <th>Status</th>
                                        <th class="text-center"><i class="fa fa-bolt"></i></th>
                                    </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <ViewCustomerAddresses where="customers" ref="viewCustomerAddressPopUp"/>
        <UpdateCustomer ref="updateCustomerPopUp"/>
    </section>
</template>

<script>
    import PageTitle from '@/components/layout_components/PageTitle'
    import ViewCustomerAddresses from '@/components/customers/ViewCustomerAddresses'
    import UpdateCustomer from '@/components/customers/UpdateCustomer'
    import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber";

    export default {
        name: "Customers",
        components: {
          SearchCustomerByNameAndContactNumber,
            PageTitle,
            ViewCustomerAddresses,
            UpdateCustomer
        },
        data:function() {
            return {
                dtTable:'',
                customerStatus:'',
                customerAddressDeleted:"",
                restaurantId:0,
                userRole: "",
                selectedCustomer: ""
            };
        },        
        mounted: function (){
            this.userRole= this.$store.state.user.userRolesById[0].role;
            let self = this;
            let processingURL = this.$store.state.mainAppURL + "customers/get_all_customers";
            let user = this.$store.state.user;
            this.dtTable = $('#dtTable').DataTable({
                "processing": true,
                "serverSide": true,
                "pagingType": "simple",
                autoWidth: false,
                "dom":'ltipr',
                "lengthMenu": [10, 25, 50, 100, 250],
                "order": [[0, "desc"]],
                'language': {
                    //'loadingRecords': 'Please wait - loading...',
                    'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
                        '                <div class="sk-double-bounce1"></div>\n' +
                        '                <div class="sk-double-bounce2"></div>\n' +
                        '              </div>'
                },
                "ajax": {
                    url: processingURL,
                    type: "post",
                    data: function ( d ) {
                        if (user.userRolesById[0].role==="ROLE_USER" || user.userRolesById[0].role==="ROLE_FRANCHISE"){
                            Object.assign(d, {restaurant_id: user.restaurant.id});
                        }
                        return JSON.stringify( d );
                    },
                    headers: {
                        "Content-type": "application/json; charset=utf-8"
                    },
                    beforeSend:  (xhr) => {
                        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
                    },
                    statusCode: {
                      401: () => {
                        this.updateRefreshTokenInDataTable(this.dtTable);
                      }
                    }
                },
                "columnDefs": [
                    { "orderable": false, "targets": [1,2,3,4,5,8] },
                    { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9]},
                ],
                "columns": [
                    { "data": "id", "name":"id" },
                    { "data": "name","name":"name" },
                    { "data": "contact1","name":"contact1" },
                    {
                        "data": "contact2","name":"contact2",
                        "render": function(data){
                            return (data === '' || data === null) ? "N/A" : data;
                        }
                    },
                    {
                        "data": "contact3","name":"contact3",
                        "render": function(data){
                            return (data === '' || data === null) ? "N/A" : data;
                        }
                    },
                    {
                        "data": "email","name":"email",
                        "render": function(data){
                            return (data === '' || data === null) ? "N/A" : data;
                        }
                    },
                    {
                        "data": "created",
                        "name":"created",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "modified",
                        "name":"modified",
                        "render": function (data) {
                          return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
                        }
                    },
                    {
                        "data": "customerStatus","name":"customerStatus",
                        "render": function(data){
                            return (data === 'active') ? "<label class='label label-success'>"+data+"</label>" :
                                "<label class='label label-danger'>"+data+"</label>";
                        }
                    },
                    {
                        "data": "action","name":"action",
                        "render": function(data, type, row){
                            return "<a data-id='"+row.id+"' data-name='"+row.name+"' data-status='"+row.customerStatus+"' class='detail_btn'>Addresses</a>" +
                                "|<a data-id='"+row.id+"' class='updateCustBtn'>Update Customer</a>";
                        }
                    }
                ],
                "drawCallback": function( settings ) {
                    $(".m_tip").tooltip();
                    $(".detail_btn").click(function () {
                        let customerId =  $(this).attr("data-id");
                        let customerName =  $(this).attr("data-name");
                        let customerStatus =  $(this).attr("data-status");
                        self.$refs.viewCustomerAddressPopUp.load(customerId, customerName, customerStatus);
                    });
                    $(".updateCustBtn").click(function () {
                        let customerId = $(this).attr("data-id");
                        self.$refs.updateCustomerPopUp.load(customerId);
                    });
                },
                // "dom": 'lTfigt',
                "tableTools": {
                    "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
                }
            });
            $.fn.dataTable.ext.errMode = 'none';
            $(".refresh_filter_customer_btn").click(function(){
                for(var i=0; i <= 8; i++){
                    self.dtTable.column(i).search( '' );
                }
                self.customerStatus="";
                self.customerAddressDeleted=""
                self.$refs.searchCustomerComponent.selectedCustomerTemp = null;
                self.$refs.searchCustomerComponent.customers = [];
                self.selectedCustomer = "";
                self.dtTable.draw();
            });
            $(".search_filter_customer_btn").click(function(){
                self.dtTable.column(7).search( self.customerAddressDeleted )
                self.dtTable.column(8).search( self.customerStatus );
                self.dtTable.column(0).search( self.selectedCustomer );
                self.dtTable.draw();
            });
        },
        methods:{
            loadEmptyCustomer: function () {
                this.$refs.updateCustomerPopUp.load(0);
            }
        }
    }
</script>

<style scoped>
.col-md-3{
  height: 80px;
}
</style>
